import React, { useEffect } from 'react';
import css from './MailChipForm.module.css';
import BrandIconCard from '../components/BrandIconCard/BrandIconCard';
import { loadMailchimpScript, removeMailchimpScript } from '../util/loadMailChip';

const MailchimpSubscribe = () => {
  useEffect(() => {
  
    loadMailchimpScript(true);
    return () => {
      console.log("Mailchimp script removed");
      removeMailchimpScript(false);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    const formData = new FormData(form); 
    try {
      await fetch(form.action, {
        method: 'POST',
        mode: 'no-cors',  
        body: formData,
      }); 
      alert('Subscribed successfully!');
      form.reset();
    } catch (error) {
      console.error('Subscription error:', error);
      alert('There was an issue subscribing.');
    }
  };

  return (
    <div
      id="mc_embed_signup"
      style={{ fontFamily: 'Helvetica, Arial, sans-serif', width: '100%' }}
    >
      <style>{`
        #mc_embed_signup input {
          width: 100%;
          padding: 0.5rem 1rem;
          border-radius: 0.5rem;
          border: 1px solid var(--orange);
          background: transparent;
          color: white;
        }
        #mc_embed_signup .button {
          background-color: var(--orange);
          color: white;
          border: none;
          padding: 0.5rem 1rem;
          border-radius: 0.5rem;
          cursor: pointer;
          margin-top: 1rem;
        }
        #mc_embed_signup label,
        #mc_embed_signup .indicates-required {
          color: white;
        }
      `}</style>

      <form
        action="https://fijianhost.us17.list-manage.com/subscribe/post?u=0cb413e08101a0c8e7333d7ac&amp;id=5c08b9fcfb&amp;f_id=0098e4e3f0"
        method="POST"
        onSubmit={handleSubmit}
        noValidate
        className="validate"
      >
        <div className={css.inputWrapper}>
          <span className={css.emailIcon}>
            <BrandIconCard type="email" />
          </span>
          <input
            type="email"
            name="EMAIL"
            id="mce-EMAIL"
            required
            aria-required="true"
            className={`${css.newsletterInput} required email`}
            placeholder='Example@Gmail.com'
          />
          <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
            <input
              type="text"
              name="b_0cb413e08101a0c8e7333d7ac_5c08b9fcfb"
              tabIndex="-1"
              defaultValue=""
              className={css.newsletterInput}
            />
          </div>
        </div>

        <input
          type="submit"
          name="subscribe"
          id="mc-embedded-subscribe"
          className={css.newsletterButton}
          value="Sign Up Now"
        />
      </form>
    </div>
  );
};

export default MailchimpSubscribe;
